import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { I18NEXT_SERVICE } from 'angular-i18next';
import { BdeoToastService } from '@bdeo/webcomponents';

type GetByNumberOptions = {
  normalized?: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class CaseService {
  private readonly authService = inject(AuthService);
  private readonly httpClient = inject(HttpClient);
  private readonly i18NextService = inject(I18NEXT_SERVICE);

  public async getByNumber(caseNumber: string, options: GetByNumberOptions = {}): Promise<{ id: string }> {
    const requestBody = {
      access_token: this.authService.getAccessToken(),
      case_number: caseNumber,
      normalized: options.normalized
    };

    const requestHeaders = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    // TO DO: Añadir este método a la especificación de la API privada o al menos tipar la respuesta
    const response = await firstValueFrom(
      this.httpClient.post<{ case: { id: string } }>(`${environment.baseUrl}/case-by-number`, requestBody, requestHeaders)
    );

    return response.case;
  }

  public create(caseNumber: string): Promise<{ success: boolean; id: string }> {
    try {
      const requestBody = {
        access_token: this.authService.getAccessToken(),
        entity: {
          number: caseNumber
        }
      };

      const requestHeaders = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      };

      return firstValueFrom(
        this.httpClient.post<{ success: boolean; id: string }>(`${environment.baseUrl}/case-create`, requestBody, requestHeaders)
      );
    } catch (error) {
      const message = this.i18NextService.t('brokers:errors.case_creation_error');
      BdeoToastService.error(message);
      throw new Error(message);
    }
  }
}
